import styled from "styled-components";

export const Container = styled.div`
  border: 20px solid #efefef;
  margin-bottom: 2em;
  padding: 1em;
`;

export const Title = styled.h2`
  text-transform: uppercase;
  font-size: 1rem;
  line-height: 1;
  font-family: "Ubuntu", sans-serif;
  font-weight: 700;
`;
